import { t } from 'i18n';
import React from 'react';
import { getUserSelectedInfo } from './../helpers';
import { useGlobalData } from 'contexts';
import { useEffect, useState } from 'react';
import { userSelectedConstants } from '../constants';
import { setUserSelectedInfo } from '../helpers';
import { Body } from '@teko/ds-desktop';

export const useRegionPicker = () => {
  const { isMobile, originalTerminal } = useGlobalData();
  const terminals =
    typeof originalTerminal === 'string' ? [] : originalTerminal;
  const selectedTerminal = getUserSelectedInfo(
    userSelectedConstants.TERMINAL,
    isMobile,
  );
  const selectedLocation = getUserSelectedInfo(
    userSelectedConstants.LOCATION,
    isMobile,
  );
  const selectedTerminalId = getUserSelectedInfo(
    userSelectedConstants.TERMINAL_ID,
    isMobile,
  );
  const enableLocationFeature = terminals.every((item) => !!item.locationCode);
  const confirmedOptionIndex = terminals.findIndex((item) => {
    if (enableLocationFeature) {
      return (
        item.code === selectedTerminal && item.locationCode === selectedLocation
      );
    }
    return item.code === selectedTerminal;
  });
  const [showRegionPopup, setShowRegionPopup] = useState(false);
  const [selected, setSelected] = useState(
    confirmedOptionIndex === -1 ? 0 : confirmedOptionIndex,
  );
  const onSubmitNewLocation = () => {
    setUserSelectedInfo(
      userSelectedConstants.TERMINAL,
      terminals[selected].code,
      isMobile,
    );
    setUserSelectedInfo(
      userSelectedConstants.TERMINAL_ID,
      terminals[selected]?.id?.toString(),
      isMobile,
    );
    enableLocationFeature &&
      setUserSelectedInfo(
        userSelectedConstants.LOCATION,
        terminals[selected].locationCode,
        isMobile,
      );
    typeof window !== 'undefined' && window.location.reload();
  };
  const activeLocation =
    confirmedOptionIndex || confirmedOptionIndex === 0
      ? terminals[confirmedOptionIndex]
      : null;
  const textMsg = `Để chúng tôi có thể phục vụ quý khách tốt hơn, xin quý khách vui lòng chọn khu vực mình sinh sống`;
  // temporarily rely on the location object present terminal
  const useDropdownPicker = !!terminals[0]?.location;
  const locationLabels = useDropdownPicker
    ? ''
    : terminals.map((item, index) => {
        if (index < terminals.length - 1)
          return (
            <span key={index}>
              <b>{item.label}</b>
              {index === terminals.length - 2 ? ' ' : ', '}
            </span>
          );
        return (
          <span key={index}>
            {' '}
            {t('hoặc')}
            <b>{item.label}</b>
          </span>
        );
      });
  const onClosePopup = () => {
    if (activeLocation) {
      setShowRegionPopup(false);
      setSelected(confirmedOptionIndex === -1 ? 0 : confirmedOptionIndex);
    }
  };
  // Luôn mở popup khi chưa chọn địa chỉ giao hàng
  useEffect(() => {
    // terminalId is a new key added later
    // we want to deprecate terminalCode
    // so for site without terminalId, prompt region picker
    const isTerminalSelected = !!selectedTerminal && !!selectedTerminalId;

    // add check !activeLocation in case the list of locations changes
    // on server-side, and user
    setShowRegionPopup(
      enableLocationFeature
        ? !isTerminalSelected || !selectedLocation || !activeLocation
        : !isTerminalSelected,
    );
  }, [selectedTerminal, selectedLocation, selectedTerminalId]);
  return {
    showPopup: showRegionPopup,
    setShowPopup: setShowRegionPopup,
    onOpenPopup: () => setShowRegionPopup(true),
    onClosePopup,
    selected,
    setSelected,
    terminals,
    locationOptions: terminals.map((el, index) => ({
      text: el.label,
      value: index,
    })),
    onSubmitNewLocation,
    activeLocation,
    useDropdownPicker,
    title: (
      <Body level={1}>
        {textMsg} {locationLabels}
      </Body>
    ),
  };
};
